import { render, staticRenderFns } from "./form5_2.vue?vue&type=template&id=78fbb3c6&scoped=true&"
import script from "./form5_2.vue?vue&type=script&lang=js&"
export * from "./form5_2.vue?vue&type=script&lang=js&"
import style0 from "./form5_2.vue?vue&type=style&index=0&id=78fbb3c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fbb3c6",
  null
  
)

export default component.exports